import { C } from "@/brand/tokens";
import { brand6 } from "@/brand/contentF6";

/**
 * FounderPortrait — Katrina Bernard's professional headshot in the
 * editorial mat frame (parchment mat, brass hairline). 3:4 crop.
 */
export function FounderPortrait({ caption = "Katrina Bernard, JD, PCC", lazy = false }) {
  return (
    <figure
      data-testid="founder-portrait"
      className="w-full select-none"
      style={{ border: `1px solid ${C.brassLine}`, background: C.surfaceLight2, borderRadius: 8 }}
    >
      <div className="p-3">
        <img
          src={brand6.founderPortrait}
          alt="Katrina Bernard, JD, PCC — Founder & Principal of Faith 1st Consulting"
          loading={lazy ? "lazy" : "eager"}
          className="w-full block"
          style={{ aspectRatio: "3 / 4", objectFit: "cover", objectPosition: "center top", borderRadius: 4 }}
        />
      </div>
      {caption && (
        <figcaption
          className="px-4 pb-4 pt-1 font-inter text-[10px] uppercase font-semibold"
          style={{ color: C.inkOnLightSoft, letterSpacing: "0.22em" }}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
